import React, { useEffect, useState, useRef } from 'react';
import { Tooltip,Button, Modal, Table, Input, Checkbox, Select, Form, Typography, Spin, message, Row, Col, Popconfirm, Steps  } from 'antd';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import GenericAddRemoveMultipleRecords from "../SetupComponent/GenericAddRemoveMultipleRecordsUI";
import { CopyOutlined, DeleteOutlined,EditOutlined, TrophyFilled} from '@ant-design/icons';
import { useSelector } from 'react-redux';

const { Option } = Select;
const { Link, Title, Text } = Typography;
const { Step } = Steps;

const RecordType = ({ object }) => {
  const [recordTypes, setRecordTypes] = useState([]);
  const [layouts, setLayouts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [defaultValue, setDefaultValue] = useState(null);
  const editingInfoRef = useRef({ editMode: false, id: null });

  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editMode, setEditMode] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [editingRecordId, setEditingRecordId] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // 'list' | 'picklist'
  const [selectedItems, setSelectedItems] = useState([]);

  const [selectedRecordType, setSelectedRecordType] = useState(null);
  const [picklistFields, setPicklistFields] = useState([]);
  const [picklistModal, setPicklistModal] = useState(false);
  const [editingField, setEditingField] = useState(null);
  const security = useSelector((state) => state.data.items[0]);

  useEffect(() => {
    console.log('objectApiName',object);
    fetchLayouts();
    fetchRecordTypes();
  }, []);
  
  const fetchLayouts = async () => {
    try {
      const api = new ApiService(`${BASE_URL}/get_by_objectName/${object.name}`, {}, 'GET');
      const response = await api.makeCall();
      console.log('response::response:',response);
      setLayouts(response || []);
    } catch {
      message.error('Failed to fetch layouts');
    }
  };

  const fetchRecordTypes = async () => {
    setLoading(true);
    try {
      const api = new ApiService(`${BASE_URL}/record_types/by_object/${object?.name}`);
      const response = await api.makeCall();
      setRecordTypes(response || []);
      console.log('res for object name rec types',response);
    } catch {
      message.error('Failed to fetch record types');
    }
    setLoading(false);
  };


  const fetchPicklistFields = async (recordType) => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_fields/object/${object?.name}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
  
      const picklistOverrides = recordType?.picklist_overrides || {};
  
      const filteredFields = response
        .filter(field =>
          field.type === 'picklist' &&
          !['recordCount', 'CreatedBy', 'LastModifiedBy', 'CurrencyIsoCode'].includes(field.name)
        )
        .map(field => {
          const override = picklistOverrides[field.name] || {};  // Safe fallback
  
          return {
            field_label: field.label || field.name,
            field_name: field.name,
            all_values: field.picklist_values || [],
            selected_values: override.values || [],
            default_value: override.default_value || null,
            key: field._id
          };
        });
      setPicklistFields(filteredFields);
    } catch {
      message.error('Failed to fetch picklist fields');
    }
  };
  


  const handleCreateNew = () => {
    if (security?.system_settings?.record_type?.create === false) {
      message.error('You do not have permission to create ');
      return;
    }
    
    setEditMode(false);
    editingInfoRef.current = { editMode: false, id: null };
    setEditingRecordId(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleSaveRecordType = async (values) => {
    try {
      // Fetch picklist fields here if not available
      
        const apiFieldPicklist = new ApiService(
          `${BASE_URL}/mt_fields/object/${object?.name}`,
          { 'Content-Type': 'application/json' },
          'GET'
        );
        const response = await apiFieldPicklist.makeCall();
  
       const picklists = response.filter(field =>
          field.type === 'picklist' &&
          !['recordCount', 'CreatedBy', 'LastModifiedBy', 'CurrencyIsoCode'].includes(field.name)
        );
      console.log('picklists',picklists)

      const overrides = {};
      picklists.forEach(field => {
        overrides[field.name] = {
          values: field.picklist_values || [],
          default_value: null
        };
      });
  
      const body = {
        record_type: {
          object_name: object?.name,
          name: values.name,
          label: values.label,
          description: values.description || '',
          layout_id: values.layout || null,
          active: values.active,
          picklist_overrides: overrides
        }
      };
      
      const { editMode, id } = editingInfoRef.current;
      console.log('editMode::',editMode);
      console.log('editingRecordId::',id);
      const api = editMode && id
        ? new ApiService(`${BASE_URL}/record_types/${id}`, { 'Content-Type': 'application/json' }, 'PUT', JSON.stringify(body))
        : new ApiService(`${BASE_URL}/record_types`, { 'Content-Type': 'application/json' }, 'POST', JSON.stringify(body));
  
      await api.makeCall();
      message.success('Record Type saved');
      setModalVisible(false);
      fetchRecordTypes();
    } catch {
      message.error('Failed to save Record Type');
    }
  };
  
  

  const handleEditRecordType = async (record) => {
    if (security?.system_settings?.record_type?.edit === false) {
          message.error('You do not have permission to edit ');
          return;
        }
    try {
      const api = new ApiService(`${BASE_URL}/record_types/${record?._id}`);
      const response = await api.makeCall();
    //   const data = response;
      
      form.setFieldsValue({
        name: response.name,
        label: response.label,
        description: response.description,
        active: response.active, // assume always active
        layout: response.layout_id
      });

      setEditMode(true);
      setEditingRecordId(record.id);
      editingInfoRef.current = { editMode: true, id: record._id };

      setModalVisible(true);
    } catch {
      message.error('Failed to load record type details');
    }
  };

  const handleDeleteRecordType = async (record) => {
    if (security?.system_settings?.record_type?.delete === false) {
      message.error('You do not have permission to delete ');
      return;
    }
    try {
      const api = new ApiService(`${BASE_URL}/record_types/${record?._id}`, { 'Content-Type': "application/json" }, 'DELETE');
      await api.makeCall();
      message.success('Record Type deleted');
      fetchRecordTypes();
    } catch {
      message.error('Failed to delete Record Type');
    }
  };



  const columns = [
    {
      title: 'Name',
      dataIndex: 'label',
      render: (text, record) => (
        <Link
          onClick={(e) => {
            // e.stopPropagation(); // prevent row click
            if (security?.system_settings?.record_type?.edit === false) {
              message.error('You do not have permission to edit');
              return;
            }
            // Only trigger Name-specific behavior
            setSelectedRecordType(record);
            console.log('record is ::',record);
            fetchPicklistFields(record);
            setViewMode('detail'); // or 'picklist' depending on what you want
          }}
        >
          {text}
        </Link>
      ),
    },
    
    { title: 'API Name', dataIndex: 'name' },
    { title: 'Description', dataIndex: 'description' },
    // { title: 'Active', dataIndex: 'active' },

  ];
  columns.push({
    title: 'Action',
    key: 'operation',
    render: (_, layout) => (
      <>
       <Tooltip title="Edit">
        <EditOutlined
            onClick={(e) => {
            e.stopPropagation();  // prevent triggering parent row events
            handleEditRecordType(layout, false);
            }}
            style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
        />
        </Tooltip>                 


        <Tooltip title="Delete">
        <Popconfirm
            title="Are you sure you want to delete this item?"
            okText="Yes"
            cancelText="No"
            onConfirm={(e) => {
                e?.stopPropagation(); // prevent name click
                handleDeleteRecordType(layout);
            }}
            onCancel={(e) => {
                e?.stopPropagation(); // ALSO stop propagation on "No"
            }}
        >

            <DeleteOutlined
            onClick={(e) => e.stopPropagation()} // prevent link from triggering
            style={{ color: 'red', marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
            />
        </Popconfirm>
        </Tooltip>

      </>
    ),
  });

  const generateApiName = (label) => {
    return label
      .replace(/[^a-zA-Z]/g, '') // Remove non-alphabet characters
      .replace(/\s+/g, '')       // Remove all spaces
      .trim();
  };
  

  const handlePicklistSave = async ({ recordTypeId, editingField, default_value }) => {
    try {
        console.log('default_valuedefault_value::',default_value);
      if (!editingField.selected_values || editingField.selected_values.length === 0) {
        message.error('Please select at least one value before saving.');
        return;
      }
  
      const currentOverrides = selectedRecordType.picklist_overrides || {};
      const updatedOverrides = {
        ...currentOverrides,
        [editingField.field_name]: {
          default_value: default_value || null,
          values: editingField.selected_values,
        }
      };
  
      const payload = {
        record_type: {
          picklist_overrides: updatedOverrides
        }
      };
  
      const api = new ApiService(
        `${BASE_URL}/record_types/${recordTypeId}`,
        { 'Content-Type': 'application/json' },
        'PUT',
        JSON.stringify(payload)
      );
  
      await api.makeCall();
      message.success('Picklist updated');
      setPicklistModal(false);
  
      const updatedRecordTypeApi = new ApiService(`${BASE_URL}/record_types/${recordTypeId}`);
      const updatedRecordType = await updatedRecordTypeApi.makeCall();
  
      setSelectedRecordType(updatedRecordType);
      fetchPicklistFields(updatedRecordType);
  
    } catch {
      message.error('Failed to save picklist');
    }
  };
  
  
  
  const handleRowClick = (recordType) => {
    setSelectedRecordType(recordType);
    fetchPicklistFields(recordType); // 👈 this injects selected values correctly
    setViewMode('detail');
  };
  
  
  
  return (
    <div>
      {viewMode === 'list' ? (
        <>
          <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
            <Col><Title level={4}>Record Type</Title></Col>
            <Col>
              <Button type="primary" onClick={handleCreateNew}>Create New Record Type</Button>
            </Col>
          </Row>
  
          <Spin spinning={loading}>
            <Table 
            columns={columns} 
            dataSource={recordTypes} 
            // onRow={(record) => ({
            //     onClick: () => handleRowClick(record)
            // })} 
            rowKey="_id" 
        />
          </Spin>
        </>
      ) : (
        <>
          <Button onClick={() => setViewMode('list')} style={{ marginBottom: 16 }}>
            Back
          </Button>
          <Title level={5}>Record Type: {selectedRecordType?.label}</Title>
  
          <Table
            columns={[
                { title: 'Picklist Field', dataIndex: 'field_label' }, // use field_label for display name
                {
                title: 'Selected Values',
                dataIndex: 'selected_values',
                render: (selected) => (Array.isArray(selected) ? selected.join(', ') : '')
                },
                {
                title: 'Actions',
                render: (_, record) => (
                    <Button
                    onClick={() => {
                        setEditingField(record);
                        setPicklistModal(true);
                        // setDefaultValue(editingField?.default_value);
                        setCurrentStep(0);
                    }}
                    >
                    Edit
                    </Button>
                )
                }
            ]}
            dataSource={picklistFields}
            rowKey="key"
            style={{ marginTop: 16 }}
            />

        </>
      )}
  
      <Modal
        title={editMode ? 'Edit Record Type' : 'Create New Record Type'}
        visible={modalVisible}
        zIndex={1002}   // higher than sidebar
        onCancel={() => setModalVisible(false)}
        onOk={() => form.submit()}
      >
        <Form form={form} layout="vertical" onFinish={handleSaveRecordType}>
          
          <Form.Item name="label" label="Label" rules={[{ required: true }]}>
            <Input
            onBlur={(e) => {
                const labelValue = e.target.value;
                const apiName = generateApiName(labelValue);
                form.setFieldsValue({ name: apiName });
              }}
            />
          </Form.Item>

          <Form.Item name="name" label="API Name" rules={[{ required: true }]}>
            <Input disabled={editMode} />
          </Form.Item>
  
          <Form.Item name="description" label="Description">
            <Input.TextArea rows={3} />
          </Form.Item>
        <Form.Item
            name="active"
            valuePropName="checked"  // binds checkbox state
            >
            <Checkbox>Active</Checkbox>
        </Form.Item>

          <Form.Item name="layout" label="Layout">
            <Select placeholder="Select Layout">
              {layouts.map(layout => (
                <Option key={layout._id} value={layout._id}>{layout.layout_name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
  
      <Modal
  title={`Edit Picklist: ${editingField?.field_name}`}
  visible={picklistModal}
  zIndex={1002}   // higher than sidebar
  onCancel={() => {
    setPicklistModal(false);
    setCurrentStep(0);
    setDefaultValue(null);
  }}
  footer={[
    currentStep === 1 && (
      <Button
        key="back"
        onClick={() => setCurrentStep(0)}
      >
        Back
      </Button>
    ),
    currentStep === 0 && (
      <Button
        key="next"
        type="primary"
        onClick={() => {
          if (!editingField.selected_values || editingField.selected_values.length === 0) {
            message.error('Please select at least one value');
            return;
          }
          const isDefaultValid = editingField.selected_values.includes(editingField.default_value);

          // Set defaultValue only if it's in selected values; otherwise null
          setDefaultValue(isDefaultValid ? editingField.default_value : null);
                  setCurrentStep(1);
        }}
      >
        Next
      </Button>
    ),
    currentStep === 1 && (
        <Button
        key="save"
        type="primary"
        onClick={() =>
            handlePicklistSave({
              recordTypeId: selectedRecordType._id,
              editingField,
              default_value: defaultValue
            })
          }
          
      >
        Save
      </Button>
      
    )
  ]}
>
  <Steps current={currentStep} style={{ marginBottom: 16 }}>
    <Steps.Step title="Select Values" />
    <Steps.Step title="Set Default" />
  </Steps>

  {currentStep === 0 && (
    <GenericAddRemoveMultipleRecords
      titleLeft="Available Values"
      titleRight="Selected Values"
      dataSource={(editingField?.all_values || []).map((item) => ({
        key: item,
        label: item,
        _id: item
      }))}
      selectedKeys={editingField?.selected_values}
      onUpdateSelectedKeys={(newSelectedKeys) => {
        setEditingField({ ...editingField, selected_values: newSelectedKeys });
      }}
      columnsLeft={[{ title: 'Value', dataIndex: 'label' }]}
      columnsRight={[{ title: 'Selected', dataIndex: 'label' }]}
      searchFields={['label']}
    />
  )}

  {currentStep === 1 && (
    <>
      <div style={{ marginBottom: 8 }}>Select Default Picklist Value:</div>
      <Select
        style={{ width: '100%' }}
        value={defaultValue}
        allowClear
        onChange={(value) => setDefaultValue(value)}
        >
        {(editingField?.selected_values || []).map((val) => (
          <Select.Option key={val} value={val}>
            {val}
          </Select.Option>
        ))}
      </Select>
    </>
  )}
</Modal>


    </div>
  );
  
};

export default RecordType;